import { Badge } from "@/components/ui/badge";
import { ProcessSteps } from "@/components/content/ProcessSteps";
import { ServiceDetails } from "@/components/content/ServiceDetails";
import { LocationInfo, ServiceAreas } from "@/components/content/LocationInfo";
import { sectionContent } from "@/config/contentConfig";

export const ContentSections = () => {
  return (
    <>
      {/* Detailed Services Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <Badge className="mb-4 gradient-primary text-white border-0">{sectionContent.services.badge}</Badge>
          <h2 className="text-4xl md:text-5xl font-display font-bold mb-6">
            {sectionContent.services.title}
          </h2>
          <p className="text-xl text-muted-foreground max-w-4xl mx-auto leading-relaxed">
            {sectionContent.services.description}
          </p>
        </div>

        <ServiceDetails />
        </div>
      </section>

      {/* Process and Practical Info */}
      <section className="py-20 bg-gradient-sky">
        <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <Badge className="mb-4 gradient-fun text-white border-0">{sectionContent.process.badge}</Badge>
          <h2 className="text-4xl md:text-5xl font-display font-bold mb-6">
            {sectionContent.process.title}
          </h2>
        </div>

        <ProcessSteps />
        </div>
      </section>

      {/* Location and Contact Info */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <Badge className="mb-4 gradient-secondary text-white border-0">{sectionContent.location.badge}</Badge>
          <h2 className="text-4xl md:text-5xl font-display font-bold mb-6">
            {sectionContent.location.title}
          </h2>
          <p className="text-xl text-muted-foreground max-w-4xl mx-auto leading-relaxed">
            {sectionContent.location.description}
          </p>
        </div>

        <LocationInfo />

        <ServiceAreas />
        </div>
      </section>
    </>
  );
};